import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {TechnicalDeviceApiService} from '@api/technical-device.api.service';
import {BehaviorSubject} from 'rxjs';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';
import SummaryInfo = TechnicalDeviceNamespace.SummaryInfo;
import {Subject} from 'rxjs';
import {merge} from 'rxjs';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {TechnicalDeviceElementGroupsPagesService} from './element-groups/technical-device-element-groups-pages.service';
import {TechnicalDeviceElementsPagesService} from './elements/technical-device-elements-pages.service';
import {TechnicalDeviceDocumentsPagesService} from './documents/technical-device-documents-pages.service';

@Injectable()
export class TechnicalDeviceDataService implements OnDestroy {
    private _summaryInfo$ = new BehaviorSubject<SummaryInfo>(null);

    public summaryInfo$ = this._summaryInfo$.pipe(

    );

    /**
     * Создан/Изменен объект документации.
     */
    public documentationCreated$ = new Subject();
    public documentationUpdated$ = new Subject();
    public documentationRemoved$ = new Subject();


    public elementCreated$ = new Subject();
    public elementRemoved$ = new Subject();


    public elementGroupCreated$ = new Subject();
    public elementGroupRemoved$ = new Subject();
    public elementGroupUpdated$ = new Subject();

    public technicalCardRemoved$ = new Subject();
    public technicalCardUpdated$ = new Subject();

    public conclusionRemoved$ = new Subject();


    /**
     * Have to be filled in parent component
     */
    public deviceId: number;

    public workingObjectId: number;

    constructor(
        private api: TechnicalDeviceApiService,
        private elementGroupsPagesService: TechnicalDeviceElementGroupsPagesService,
        private elementPagesService: TechnicalDeviceElementsPagesService,
        private documentationPagesService: TechnicalDeviceDocumentsPagesService,
    ) {
        merge(
            this.elementCreated$,
            this.elementGroupCreated$,
            this.elementGroupRemoved$,
            this.elementGroupUpdated$,
            this.technicalCardRemoved$,
            this.technicalCardUpdated$,
            this.conclusionRemoved$,
            this.elementRemoved$,
        ).pipe(
            untilDestroyed(this)
        ).subscribe(() => {
            this.updateSummaryInfo();
        });

        merge(
            this.elementGroupCreated$,
            this.elementGroupRemoved$,
            this.elementGroupUpdated$,
            this.technicalCardRemoved$,
            this.technicalCardUpdated$,
        ).pipe(
            untilDestroyed(this)
        ).subscribe(() => {
            this.elementGroupsPagesService.updateItems();
        });

        merge(
            this.elementCreated$,
            this.elementRemoved$,
            this.conclusionRemoved$,
        ).pipe(
            untilDestroyed(this)
        ).subscribe(() => {
            this.elementPagesService.updateItems();
        });

        merge(
            this.documentationCreated$,
            this.documentationUpdated$,
            this.documentationRemoved$,
        ).pipe(
            untilDestroyed(this)
        ).subscribe(() => {
            this.documentationPagesService.updateItems();
        });
    }

    /**
     * Установить значение сводных данных
     * @param info
     */
    setSummaryInfo(info: SummaryInfo) {
        this._summaryInfo$.next(info);
    }

    /**
     * Обновить значение сводных данных
     */
    private updateSummaryInfo() {
        this.api.get({
            url: this.api.getSummaryInfoPath(this.deviceId)
        }).subscribe((info: SummaryInfo) => {
            this._summaryInfo$.next(info);
        }, () => {

        });
    }

    ngOnDestroy() {
        this._summaryInfo$.complete();
        this.documentationCreated$.complete();
        this.elementCreated$.complete();
        this.elementRemoved$.complete();
        this.elementGroupCreated$.complete();
        this.elementGroupRemoved$.complete();
        this.elementGroupUpdated$.complete();
        this.technicalCardRemoved$.complete();
        this.technicalCardUpdated$.complete();
        this.conclusionRemoved$.complete();
    }
}
